import PropTypes from 'prop-types';
// import {clearAnalyzeDatalist} from '../analyze/actions';
import { PureComponent } from 'react';

import { withAppProps } from 'utils/react/withAppProps';

/**
 * Highorder compoment to prefetch data
 * @param {Object} args
 * @param {boolean} [args.fetchOnLocationChange]
 * @param {array} [args.actions]
 * @param {RegExp|string} [args.locationChangeExclusionPattern]
 * @returns {function}
 */
export default function fetch({
  fetchOnLocationChange = true,
  actions = [],
  locationChangeExclusionPattern,
}) {
  return (Wrapped) =>
    withAppProps(
      class Fetch extends PureComponent {
        static propTypes = {
          // analyze: PropTypes.object,
          dispatch: PropTypes.func,
          location: PropTypes.object,
          params: PropTypes.object,
        };

        constructor(props) {
          super(props);
          this.state = {
            render: true,
          };
        }

        componentDidMount() {
          this.callFetch(this.props);
        }

        // // This enables client side fetching, method is called only in browser.
        // componentWillMount() {
        //   // Dispatch is injected by react-redux.
        //   // React router injects location and params for every routed component.
        //   this.callFetch(this.props);
        // }

        // TODO: Fetch if last location pathname has changed.
        componentDidUpdate(prevProps) {
          const { location } = this.props;
          const currentPath = location.pathname + location.search;
          if (
            fetchOnLocationChange &&
            (!locationChangeExclusionPattern ||
              !RegExp(locationChangeExclusionPattern).test(currentPath)) &&
            currentPath !==
              prevProps.location.pathname + prevProps.location.search
          ) {
            this.callFetch(this.props);
          }
        }

        callFetch = (props) => {
          const { dispatch, location, params } = props;
          for (const action of actions) {
            dispatch(action({ location, params }));
          }
        };

        render() {
          const { render } = this.state;
          if (render === false) {
            return <div />;
          }
          return <Wrapped {...this.props} />;
        }
      },
    );
}
